"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DefaultDashboardDateFilter = void 0;
var tslib_1 = require("tslib");
// (C) 2021-2023 GoodData Corporation
var react_1 = tslib_1.__importStar(require("react"));
var sdk_ui_filters_1 = require("@gooddata/sdk-ui-filters");
var dashboardFilterConverter_1 = require("../../../_staging/dashboard/dashboardFilterConverter");
var dateFilterOptionMapping_1 = require("../../../_staging/dateFilterConfig/dateFilterOptionMapping");
var model_1 = require("../../../model");
/**
 * Default implementation of the attribute filter to use on the dashboard's filter bar.
 *
 * This will use the SDK's DateFilter with the button styled same as we have it today on KD.
 *
 * @alpha
 */
exports.DefaultDashboardDateFilter = function (props) {
    var settings = model_1.useDashboardSelector(model_1.selectSettings);
    var capabilities = model_1.useDashboardSelector(model_1.selectBackendCapabilities);
    var locale = model_1.useDashboardSelector(model_1.selectLocale);
    var isInEditMode = model_1.useDashboardSelector(model_1.selectIsInEditMode);
    var filter = props.filter, onFilterChanged = props.onFilterChanged, config = props.config, readonly = props.readonly;
    var _a = tslib_1.__read(react_1.useState(""), 2), lastSelectedOptionId = _a[0], setLastSelectedOptionId = _a[1];
    var _b = react_1.useMemo(function () {
        return dateFilterOptionMapping_1.matchDateFilterToDateFilterOptionWithPreference(filter, config.dateFilterOptions, lastSelectedOptionId);
    }, [filter, config.dateFilterOptions, lastSelectedOptionId]), dateFilterOption = _b.dateFilterOption, excludeCurrentPeriod = _b.excludeCurrentPeriod;
    var onApply = react_1.useCallback(function (option, exclude) {
        setLastSelectedOptionId(option.localIdentifier);
        onFilterChanged(dashboardFilterConverter_1.dateFilterOptionToDashboardDateFilter(option, exclude), option.localIdentifier);
    }, [onFilterChanged]);
    var dateFormat = settings.formatLocale
        ? sdk_ui_filters_1.getLocalizedIcuDateFormatPattern(settings.formatLocale)
        : settings.responsiveUiDateFormat;
    return (react_1.default.createElement(sdk_ui_filters_1.DateFilter, { excludeCurrentPeriod: excludeCurrentPeriod, selectedFilterOption: dateFilterOption, dateFilterMode: readonly ? "readonly" : "active", filterOptions: config.dateFilterOptions, availableGranularities: config.availableGranularities, customFilterName: config.customFilterName, onApply: onApply, dateFormat: dateFormat, locale: locale, isTimeForAbsoluteRangeEnabled: !!capabilities.supportsTimeGranularities, isEditMode: isInEditMode }));
};
//# sourceMappingURL=DefaultDashboardDateFilter.js.map